// extracted by mini-css-extract-plugin
module.exports = {"noPadding":"Customer_noPadding__G7D07","questionProvider":"Customer_questionProvider__TiEyD"};